<template>
    <section>
        <b-overlay
          id="overlay-background"
          :show="overlay"
          :opacity="0.5"
          rounded="sm"
          :spinner-type="overlay_type"
        >
            <b-container id="signup">
                <h2 class="text-center mb-3">報名發表會</h2>
                <b-form class="signup">
                <b-row class="mb-3">
                    <b-col sm="2">
                        <label>姓名</label>
                    </b-col>
                    <b-col sm="10" md="auto">
                        <b-form-input placeholder="請輸入姓名" v-model="SignData.name"   :state="CheckState(SignData.name,true)"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="2">
                        <label>單位</label>
                    </b-col>
                    <b-col sm="10" md="auto">
                        <b-form-radio name="govORsch" v-model="govORsch" value="0">政府</b-form-radio>
                        <b-form-radio name="govORsch" v-model="govORsch" value="1">學院</b-form-radio>
                        <b-form-radio name="govORsch" v-model="govORsch" value="2">公司</b-form-radio>
                    </b-col>
                    <b-col sm="10" md="auto">
                        <b-row class="mb-1">
                            <b-form-select v-if="govORsch != 2 && govORsch == 1" v-model="selected" :options="options2" :state="CheckState(selected,true)"></b-form-select>
                        </b-row>
                        <b-row class="mb-1">
                            <b-form-input v-if="govORsch == 0" v-model="SignData.government" placeholder="請輸入政府單位" :state="CheckState(SignData.government,true)"></b-form-input>
                            <b-form-input v-if="govORsch == 2" v-model="SignData.company"  placeholder="請輸入公司名稱" :state="CheckState(SignData.company ,true)"></b-form-input>
                        </b-row>
                        <b-row class="mb-1">
                            <b-form-input v-model="SignData.position"  placeholder="請輸入職稱" :state="CheckState(SignData.position,true)"></b-form-input>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="2">
                        <label>性別</label>
                    </b-col>
                    <b-col sm="10" md="auto">
                        <b-form-radio name="gender" v-model="SignData.sex" value="0">男</b-form-radio>
                        <b-form-radio name="gender" v-model="SignData.sex" value="1">女</b-form-radio>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="2">
                        <label>電話</label>
                    </b-col>
                    <b-col sm="10" md="auto">
                        <b-form-input  placeholder="請輸入電話" v-model="SignData.phone" :state="CheckState(SignData.phone,true)"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="2">
                        <label>身分證號碼 (非必填)</label>
                    </b-col>
                    <b-col sm="10" md="auto">
                        <b-form-input placeholder="請輸入身分證號碼" v-model="SignData.mid"></b-form-input>
                        <b-form-invalid-feedback :state="CheckMid">請填寫正確的身分證格式</b-form-invalid-feedback>
                        <a>如要申請公務人員終身學習時數，身分證請務必填寫。</a>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="2">
                        <label>電子信箱</label>
                    </b-col>
                    <b-col sm="10" md="auto" id="cmail">
                        <b-form-input  type="email" placeholder="請輸入電子信箱"  v-model="SignData.email" :state="CheckState(SignData.email,CheckMail)"></b-form-input>
                        <b-form-invalid-feedback :state="CheckMail">請填寫正確的Email格式</b-form-invalid-feedback>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="2">
                        <label>飲食需求</label>
                    </b-col>
                    <b-col sm="10" md="auto">
                        <b-form-radio name="Lunch" v-model="SignData.Lunch" value="0">葷食</b-form-radio>
                        <b-form-radio name="Lunch" v-model="SignData.Lunch" value="1">素食</b-form-radio>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="2">
                        <label>參加的場次</label>
                    </b-col>
                    <b-col sm="10" md="auto">
                        <b-form-checkbox v-model="session1">DTM開放資料與加值應用</b-form-checkbox>
                        <b-form-checkbox v-model="session2">三維國家底圖成果發表</b-form-checkbox>
                        <b-form-checkbox v-model="session3">圖資整合、流通與應用</b-form-checkbox>
                        <b-form-checkbox v-model="session4">空間測繪技術成果發表</b-form-checkbox>
                    </b-col>
                </b-row>
                <hr>
                <b-row class="mb-3">
                    <b-col sm="10" offset-md="2" md="auto">
                        <b-form-checkbox v-model="terms1">我已經確認上述資料皆與證件相符</b-form-checkbox>
                        <b-form-checkbox v-model="terms2">我已同意<b-link href="#" v-b-modal.modal-1>『個資同意聲明』</b-link></b-form-checkbox>
                        <b-modal id="modal-1" title="個資同意聲明" size="lg" ok-only ok-title="關閉">
                            <dl>
                                <dt>蒐集機關</dt>
                                <dd>逢甲大學地理資訊系統研究中心、易圖科技。</dd>
                                <dt>蒐集目的</dt>
                                <dd>「內政部落實智慧國土計畫暨空間測繪技術發表會」報名之用</dd>
                                <dt>資料類別</dt>
                                <dd>個人身分證字號、姓名、生日、性別、服務單位、職稱、電子郵件、電話、手機、地址。</dd>
                                <dt>使用方式</dt>
                                <dd>由系統登錄後，於資料庫存放，由專案活動負責人員進行報名確認事宜。</dd>
                                <dt>使用期限</dt>
                                <dd>專案活動結束後或登錄公務人員學習時數後屆滿報名完成後，您得以下列聯絡方式行使查閱、更正等個人資料保護法第3條的當事人權利。</dd>
                            </dl>
                            <p>如您提供的資料不完整或不確實，將無法完成本次報名作業。</p>
                        </b-modal>
                        <b-modal id="modal-terms" v-model="modal_terms_show" title="報名失敗" size="lg" ok-only ok-title="關閉">
                            <p>請勾選個資同意聲明、確認證件，否則將無法完成本次報名作業。</p>
                        </b-modal>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="10" offset-md="2" md="auto">
                        <b-button type="button" variant="primary" size="lg"  @click="CheckTerms">送出</b-button>
                    </b-col>
                </b-row>
                </b-form>
                <b-modal id="modal-2" v-model="modal_2_show" title="報名完成" size="lg" ok-only ok-title="關閉" @ok="GoToPathHome">
                    <p>感謝您報名內政部落實智慧國土計畫暨空間測繪技術發表會。</p>
                    <p>確認信函以寄至：{{SignData.email}}</p>
                </b-modal>
                <b-modal id="modal-timeOut" v-model="modal_timeOut_show" title="報名日期已截止" size="lg" ok-only ok-title="關閉">
                    <p>報名日期: </p>
                    <p>2020/10/12 上午 11:00:00 ~ 2020/11/10 下午 11:59:00</p>
                </b-modal>
            </b-container>
        </b-overlay>
    </section>
</template>
<script>
import {apiGetOpen2,apiCheckRegister,apiGetAT_ID,apiNewRegister,apiGetKey,apiGetToken,apiGetMailToken,apiSendMail,apiSetLogRequest} from '../api/API'
export default {
    data() {
        return {
            State:true,
            session1:true,
            session2:true,
            session3:true,
            session4:true,
            terms1:false,
            terms2:false,
            govORsch:"0",
            selected: null,
            // options: [
            // { value: null, text: '請選擇單位' },
            // { value: 'CV20201006102707836', text: '內政部' },
            // { value: 'CV20201006102717785', text: '秘書室' },
            // { value: 'CV20201006102726579', text: '民政司' },
            // { value: 'CV20201006102734872', text: '戶政司' },
            // { value: 'CV20201006102742423', text: '地政司' },
            // { value: 'CV20201006102751495', text: '合作及人民團體司籌備處' },
            // { value: 'CV20201006102759701', text: '總務司' },
            // { value: 'CV20201006102807153', text: '人事處' },
            // { value: 'CV20201006102814981', text: '政風處' },
            // { value: 'CV20201006102825755', text: '會計處' },
            // { value: 'CV20201006102834270', text: '統計處' },
            // { value: 'CV20201006102841964', text: '法規委員會' },
            // { value: 'CV20201006102852110', text: '訴願審議委員會' },
            // { value: 'CV20201006102900572', text: '資訊中心' },
            // { value: 'CV20201006102907878', text: '警政署' },
            // { value: 'CV20201006102915493', text: '營建署' },
            // { value: 'CV20201006102923483', text: '消防署' },
            // { value: 'CV20201006102930353', text: '役政署' },
            // { value: 'CV20201006102937972', text: '移民署' },
            // { value: 'CV20201006102946937', text: '中央警察大學' },
            // { value: 'CV20201006102955772', text: '建築研究所' },
            // { value: 'CV20201006103002906', text: '空中勤務總隊' },
            // { value: 'CV20201006103010929', text: '國土測繪中心' },
            // { value: 'CV20201006103018328', text: '土地重劃工程處' },
            // ],
            options2: [
            { value: '', text: '請選擇單位' },
            { value: '國立政治大學', text: '國立政治大學' },
            { value: '國立清華大學', text: '國立清華大學' },
            { value: '國立臺灣大學', text: '國立臺灣大學' },
            { value: '國立臺灣師範大學', text: '國立臺灣師範大學' },
            { value: '國立成功大學', text: '國立成功大學' },
            { value: '國立中興大學', text: '國立中興大學' },
            { value: '國立交通大學', text: '國立交通大學' },
            { value: '國立中央大學', text: '國立中央大學' },
            { value: '國立中山大學', text: '國立中山大學' },
            { value: '國立臺灣海洋大學', text: '國立臺灣海洋大學' },
            { value: '國立中正大學', text: '國立中正大學' },
            { value: '國立高雄師範大學', text: '國立高雄師範大學' },
            { value: '國立彰化師範大學', text: '國立彰化師範大學' },
            { value: '國立陽明大學', text: '國立陽明大學' },
            { value: '國立臺北大學', text: '國立臺北大學' },
            { value: '國立嘉義大學', text: '國立嘉義大學' },
            { value: '國立高雄大學', text: '國立高雄大學' },
            { value: '國立東華大學', text: '國立東華大學' },
            { value: '國立暨南國際大學', text: '國立暨南國際大學' },
            { value: '國立臺北藝術大學', text: '國立臺北藝術大學' },
            { value: '國立臺灣藝術大學', text: '國立臺灣藝術大學' },
            { value: '國立臺東大學', text: '國立臺東大學' },
            { value: '國立宜蘭大學', text: '國立宜蘭大學' },
            { value: '國立聯合大學', text: '國立聯合大學' },
            { value: '國立臺南藝術大學', text: '國立臺南藝術大學' },
            { value: '國立臺南大學', text: '國立臺南大學' },
            { value: '國立臺北教育大學', text: '國立臺北教育大學' },
            { value: '國立臺中教育大學', text: '國立臺中教育大學' },
            { value: '國立體育大學', text: '國立體育大學' },
            { value: '國立金門大學', text: '國立金門大學' },
            { value: '國立臺灣體育運動大學', text: '國立臺灣體育運動大學' },
            { value: '國立屏東大學', text: '國立屏東大學' },
            { value: '臺北市立大學', text: '臺北市立大學' },
            { value: '國立臺灣科技大學', text: '國立臺灣科技大學' },
            { value: '國立雲林科技大學', text: '國立雲林科技大學' },
            { value: '國立屏東科技大學', text: '國立屏東科技大學' },
            { value: '國立臺北科技大學', text: '國立臺北科技大學' },
            { value: '國立虎尾科技大學', text: '國立虎尾科技大學' },
            { value: '國立澎湖科技大學', text: '國立澎湖科技大學' },
            { value: '國立勤益科技大學', text: '國立勤益科技大學' },
            { value: '國立臺北護理健康大學', text: '國立臺北護理健康大學' },
            { value: '國立高雄餐旅大學', text: '國立高雄餐旅大學' },
            { value: '國立臺中科技大學', text: '國立臺中科技大學' },
            { value: '國立臺北商業大學', text: '國立臺北商業大學' },
            { value: '國立高雄科技大學', text: '國立高雄科技大學' },
            { value: '國立臺灣戲曲學院', text: '國立臺灣戲曲學院' },
            { value: '國立臺南護理專科學校', text: '國立臺南護理專科學校' },
            { value: '國立臺東專科學校', text: '國立臺東專科學校' },
            { value: '東海大學', text: '東海大學' },
            { value: '輔仁大學', text: '輔仁大學' },
            { value: '東吳大學', text: '東吳大學' },
            { value: '中原大學', text: '中原大學' },
            { value: '淡江大學', text: '淡江大學' },
            { value: '中國文化大學', text: '中國文化大學' },
            { value: '逢甲大學', text: '逢甲大學' },
            { value: '靜宜大學', text: '靜宜大學' },
            { value: '長庚大學', text: '長庚大學' },
            { value: '元智大學', text: '元智大學' },
            { value: '中華大學學校財團法人中華大學', text: '中華大學學校財團法人中華大學' },
            { value: '大葉大學', text: '大葉大學' },
            { value: '華梵大學', text: '華梵大學' },
            { value: '義守大學', text: '義守大學' },
            { value: '世新大學', text: '世新大學' },
            { value: '銘傳大學', text: '銘傳大學' },
            { value: '實踐大學', text: '實踐大學' },
            { value: '高雄醫學大學', text: '高雄醫學大學' },
            { value: '南華大學', text: '南華大學' },
            { value: '真理大學', text: '真理大學' },
            { value: '大同大學', text: '大同大學' },
            { value: '慈濟學校財團法人慈濟大學', text: '慈濟學校財團法人慈濟大學' },
            { value: '臺北醫學大學', text: '臺北醫學大學' },
            { value: '中山醫學大學', text: '中山醫學大學' },
            { value: '長榮大學', text: '長榮大學' },
            { value: '中國醫藥大學', text: '中國醫藥大學' },
            { value: '玄奘大學', text: '玄奘大學' },
            { value: '亞洲大學', text: '亞洲大學' },
            { value: '開南大學', text: '開南大學' },
            { value: '佛光大學', text: '佛光大學' },
            { value: '明道學校財團法人明道大學', text: '明道學校財團法人明道大學' },
            { value: '台灣首府學校財團法人台灣首府大學', text: '台灣首府學校財團法人台灣首府大學' },
            { value: '康寧學校財團法人康寧大學', text: '康寧學校財團法人康寧大學' },
            { value: '中信金融管理學院', text: '中信金融管理學院' },
            { value: '稻江科技暨管理學院', text: '稻江科技暨管理學院' },
            { value: '馬偕學校財團法人馬偕醫學院', text: '馬偕學校財團法人馬偕醫學院' },
            { value: '法鼓學校財團法人法鼓文理學院', text: '法鼓學校財團法人法鼓文理學院' },
            { value: '學校財團法人中華浸信會基督教台灣浸會神學院', text: '學校財團法人中華浸信會基督教台灣浸會神學院' },
            { value: '臺北基督學院', text: '臺北基督學院' },
            { value: '財團法人一貫道天皇基金會一貫道天皇學院', text: '財團法人一貫道天皇基金會一貫道天皇學院' },
            { value: '台神學校財團法人台灣神學研究學院', text: '台神學校財團法人台灣神學研究學院' },
            { value: '一貫道崇德學院', text: '一貫道崇德學院' },
            { value: '台灣基督長老教會南神神學院', text: '台灣基督長老教會南神神學院' },
            { value: '朝陽科技大學', text: '朝陽科技大學' },
            { value: '南臺學校財團法人南臺科技大學', text: '南臺學校財團法人南臺科技大學' },
            { value: '崑山科技大學', text: '崑山科技大學' },
            { value: '嘉藥學校財團法人嘉南藥理大學', text: '嘉藥學校財團法人嘉南藥理大學' },
            { value: '樹德科技大學', text: '樹德科技大學' },
            { value: '龍華科技大學', text: '龍華科技大學' },
            { value: '輔英科技大學', text: '輔英科技大學' },
            { value: '明新學校財團法人明新科技大學', text: '明新學校財團法人明新科技大學' },
            { value: '弘光科技大學', text: '弘光科技大學' },
            { value: '健行學校財團法人健行科技大學', text: '健行學校財團法人健行科技大學' },
            { value: '正修學校財團法人正修科技大學', text: '正修學校財團法人正修科技大學' },
            { value: '萬能學校財團法人萬能科技大學', text: '萬能學校財團法人萬能科技大學' },
            { value: '建國科技大學', text: '建國科技大學' },
            { value: '明志科技大學', text: '明志科技大學' },
            { value: '高苑科技大學', text: '高苑科技大學' },
            { value: '大仁科技大學', text: '大仁科技大學' },
            { value: '聖約翰科技大學', text: '聖約翰科技大學' },
            { value: '嶺東科技大學', text: '嶺東科技大學' },
            { value: '中國科技大學', text: '中國科技大學' },
            { value: '中臺科技大學', text: '中臺科技大學' },
            { value: '台南家專學校財團法人台南應用科技大學', text: '台南家專學校財團法人台南應用科技大學' },
            { value: '遠東科技大學', text: '遠東科技大學' },
            { value: '光宇學校財團法人元培醫事科技大學', text: '光宇學校財團法人元培醫事科技大學' },
            { value: '景文科技大學', text: '景文科技大學' },
            { value: '中華醫事科技大學', text: '中華醫事科技大學' },
            { value: '東南科技大學', text: '東南科技大學' },
            { value: '德明財經科技大學', text: '德明財經科技大學' },
            { value: '南開科技大學', text: '南開科技大學' },
            { value: '中華學校財團法人中華科技大學', text: '中華學校財團法人中華科技大學' },
            { value: '僑光科技大學', text: '僑光科技大學' },
            { value: '廣亞學校財團法人育達科技大學', text: '廣亞學校財團法人育達科技大學' },
            { value: '美和學校財團法人美和科技大學', text: '美和學校財團法人美和科技大學' },
            { value: '吳鳳科技大學', text: '吳鳳科技大學' },
            { value: '環球學校財團法人環球科技大學', text: '環球學校財團法人環球科技大學' },
            { value: '中州學校財團法人中州科技大學', text: '中州學校財團法人中州科技大學' },
            { value: '修平學校財團法人修平科技大學', text: '修平學校財團法人修平科技大學' },
            { value: '長庚學校財團法人長庚科技大學', text: '長庚學校財團法人長庚科技大學' },
            { value: '城市學校財團法人臺北城市科技大學', text: '城市學校財團法人臺北城市科技大學' },
            { value: '大華學校財團法人大華科技大學', text: '大華學校財團法人大華科技大學' },
            { value: '醒吾學校財團法人醒吾科技大學', text: '醒吾學校財團法人醒吾科技大學' },
            { value: '文藻學校財團法人文藻外語大學', text: '文藻學校財團法人文藻外語大學' },
            { value: '華夏學校財團法人華夏科技大學', text: '華夏學校財團法人華夏科技大學' },
            { value: '慈濟學校財團法人慈濟科技大學', text: '慈濟學校財團法人慈濟科技大學' },
            { value: '致理學校財團法人致理科技大學', text: '致理學校財團法人致理科技大學' },
            { value: '宏國學校財團法人宏國德霖科技大學', text: '宏國學校財團法人宏國德霖科技大學' },
            { value: '東方學校財團法人東方設計大學', text: '東方學校財團法人東方設計大學' },
            { value: '崇右學校財團法人崇右影藝科技大學', text: '崇右學校財團法人崇右影藝科技大學' },
            { value: '台北海洋學校財團法人台北海洋科技大學', text: '台北海洋學校財團法人台北海洋科技大學' },
            { value: '大漢技術學院', text: '大漢技術學院' },
            { value: '和春技術學院', text: '和春技術學院' },
            { value: '亞東技術學院', text: '亞東技術學院' },
            { value: '南亞科技學校財團法人南亞技術學院', text: '南亞科技學校財團法人南亞技術學院' },
            { value: '蘭陽技術學院', text: '蘭陽技術學院' },
            { value: '黎明技術學院', text: '黎明技術學院' },
            { value: '經國管理暨健康學院', text: '經國管理暨健康學院' },
            { value: '大同技術學院', text: '大同技術學院' },
            { value: '臺灣觀光學院', text: '臺灣觀光學院' },
            { value: '馬偕學校財團法人馬偕醫護管理專科學校', text: '馬偕學校財團法人馬偕醫護管理專科學校' },
            { value: '仁德醫護管理專科學校', text: '仁德醫護管理專科學校' },
            { value: '樹人醫護管理專科學校', text: '樹人醫護管理專科學校' },
            { value: '慈惠醫護管理專科學校', text: '慈惠醫護管理專科學校' },
            { value: '耕莘健康管理專科學校', text: '耕莘健康管理專科學校' },
            { value: '敏惠醫護管理專科學校', text: '敏惠醫護管理專科學校' },
            { value: '育英醫護管理專科學校', text: '育英醫護管理專科學校' },
            { value: '聖母醫護管理專科學校', text: '聖母醫護管理專科學校' },
            { value: '新生醫護管理專科學校', text: '新生醫護管理專科學校' },
            { value: '崇仁醫護管理專科學校', text: '崇仁醫護管理專科學校' },
            { value: '國立空中大學', text: '國立空中大學' },
            { value: '高雄市立空中大學', text: '高雄市立空中大學' },
            ],
            SignData: {
                name: "",
                company: "",
                government: "",
                position: "",
                phone: "",
                mid: "",
                sex: "0",
                email:"",
                Lunch: "0"
            },
            modal_terms_show: false,
            modal_2_show: false,
            modal_timeOut_show:false,
            overlay: false,
            overlay_type: "border"
        }
    },
    mounted(){
        this.CheckIsOpen();
    },
    methods: {
        async SendMail(id,count) {
                try
                {
                    const token = (await apiGetMailToken()).data;
                    console.log(token);
                    var info = {
                        id: id,
                        mail: this.SignData.email,
                        name: this.SignData.name,
                        TokenID: "",
                        Token: token,
                        Page: ""
                        }
                    const sendMail = JSON.parse((await apiSendMail(info)).data);
                    console.log(sendMail);
                    if(sendMail.Status){
                        this.overlay = false;
                        this.modal_2_show = true;          
                    }
                    else
                    {
                        if(count <= 5 )
                        {
                            count++;
                            this.SendMail(id,count);
                        }
                        else
                        {
                            const token = (await apiGetMailToken()).data;
                            var lo = {
                                Id: this.SignData.email,
                                Message: "寄件失敗",
                                TokenID: "",
                                Token: token,
                                Page: ""
                                }
                            const SetLog = JSON.parse((await apiSetLogRequest(lo)).data);
                            console.error(SetLog);
                            this.overlay = false;
                            alert("寄件失敗，請聯絡相關人員 ");
                        }
                    }
                }
                catch(err)
                {
                    if(count <= 5 )
                    {
                        count++;
                        this.SendMail(id,count);
                    }
                    else
                    {
                        const token = (await apiGetMailToken()).data;
                        var logs = {
                            Id: this.SignData.email,
                            Message: err,
                            TokenID: "",
                            Token: token,
                            Page: ""
                            }
                        const SetLog = JSON.parse((await apiSetLogRequest(logs)).data);
                        console.error(SetLog);
                        this.overlay = false;
                        alert("寄件出現錯誤，請聯絡相關人員 ");
                    }
                }
        },
        async Register() {
            try
            {
                this.overlay = true;
                const key = (await apiGetKey()).data[0]["Key"];
                console.log(key);
                const token = (await apiGetToken(key)).data[0]["Token"];
                console.log(token);
                const AT_ID = (await apiGetAT_ID(token)).data[0]["AT_ID"];
                console.log(AT_ID);

                //CL20180307140909094
                var RegisterData = [
                    { RD_CLID: "CL20180307140916893", RD_Value: this.SignData.position },
                    { RD_CLID: "CL20190311193313384", RD_Value: (this.SignData.sex == "0" ? "CV20190311193344352" : "CV20190311193335665") },
                    { RD_CLID: "CL20180307140900463", RD_Value: this.SignData.phone.replace('#', '%23') },
                    { RD_CLID: "CL20180307140846991", RD_Value: this.SignData.mid },
                    { RD_CLID: "CL20180307141103300", RD_Value: ( this.SignData.Lunch == "0" ? "CV20180307141116883" : "CV20180323140015686") }
                ]

                var gscVal = "";
                var itemVal = "";
                if(this.govORsch == "0"){
                    gscVal = "CV20201022102804909";
                    itemVal = this.SignData.government;
                }
                if(this.govORsch == "1"){
                    gscVal = "CV20201022102816730";
                    itemVal = this.selected;
                }   
                if(this.govORsch == "2")
                {
                    gscVal = "CV20201016141128829";
                    itemVal = this.SignData.company;
                }               
                RegisterData.push({ RD_CLID: "CL20201006102625094", RD_Value: gscVal });
                RegisterData.push({ RD_CLID: "CL20190114173731482", RD_Value: itemVal });

                var value = "";
                if(this.session1)
                    value += "CV20201006103729190,";
                if(this.session2)
                    value += "CV20201006103739129,";
                if(this.session3)
                    value += "CV20201006103751803,";
                if(this.session4)
                    value += "CV20201022104527279,";

                RegisterData.push({ RD_CLID: "CL20201006103716740", RD_Value: value });
                
                var Register = {
                    RG_ATID: AT_ID,
                    RG_Email: this.SignData.email,
                    RG_CName: this.SignData.name,
                    RG_LName: "",
                    RG_FName: "",
                    VolumnData: RegisterData
                }
                console.log(Register);

                const NewRegister = (await apiNewRegister(token,Register));
                console.log(NewRegister.data["Result"]);

                if(NewRegister.data["Result"] == "該活動尚未開啟報名(This activity is not open yet.)"){
                    this.modal_timeOut_show=true;
                }else{
                    const isRegister = (await apiCheckRegister(this.SignData.email)).data[0]["IsRegister"];
                    if(isRegister == "true"){
                        this.SendMail(NewRegister.data["Result"],1);
                    }
                    else
                    {
                        this.overlay = false;
                        alert("報名失敗");
                    }
                }
            }
            catch(err)
            {
                console.error(err);
                alert("註冊出現錯誤，請聯絡相關人員");
            }
        },
        async CheckRegister() {
            try
            {
                const isRegister = (await apiCheckRegister(this.SignData.email)).data[0]["IsRegister"];
                if(isRegister == "false"){
                    this.Register();
                }
                else
                {
                    alert("此Emial已有報名過");
                }
            }
            catch(err)
            {
                console.error(err);
                alert("檢查出現錯誤，請聯絡相關人員");
            }
        },
        CheckState(val,CMail)
        {
            if((val == "" || !CMail) && !this.State)
                return false;
            else
                return null;
        },
        CheckData() {
            if(this.SignData.name == ""  || this.SignData.email == "" || this.SignData.position == "" || (this.SignData.mid != "" && !this.CheckMid) || this.SignData.phone == "" 
            || (this.govORsch == "0" &&  this.SignData.government == "") || (this.selected == null && this.govORsch == "1") || (this.govORsch == "2" &&  this.SignData.company == ""))
            {
                this.State = false;
                window.location.hash = "#signup"
            }
            else if((this.session1 == false) && (this.session2 == false) && (this.session3 == false) && (this.session4 == false))
            {
                alert("請至少參加一場次");
            }
            else
            {
                if(!this.CheckMail){
                    this.State = false;
                    window.location.hash = "#signup"
                }
                else{
                    this.CheckRegister();
                }       
            }
        },
        CheckTerms() {
            if(this.terms1 == false || this.terms2 == false)
            {
                this.modal_terms_show = true;
            }
            else
            {
                this.CheckData();
            }
        },
        async CheckIsOpen(){
            const key = (await apiGetKey()).data[0]["Key"];
            const token = (await apiGetToken(key)).data[0]["Token"];
            const AT_ID = (await apiGetAT_ID(token)).data[0]["AT_ID"];
            const isOpen = (await apiGetOpen2(token,AT_ID)).data[0]["IsOpen"];
            if(isOpen != "true"){
                this.modal_timeOut_show=true;
                this.overlay_type = "";
                this.overlay = true;
            }
        }

    },
    computed: {
        CheckMail () {
            const mailRegExp = new RegExp('^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$');
            return mailRegExp.test(this.SignData.email);
        },
        CheckMid () {
            const idRegExp = new RegExp('^[A-Za-z]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+$');
            return idRegExp.test(this.SignData.mid);
        }
    },
}
</script>